/* eslint-disable react/prop-types */
import { Box, Button as MuiButton } from "@mui/material";
import { Formik } from "formik";
import { omit } from "lodash/fp";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Dropdown from "../../../../components/common/new/Dropdown/Dropdown";
import InputField from "../../../../components/common/new/InputField/InputField";
import AppointmentPageTopInfo from "../../AppointmentPageTopInfo";
import { APPOINTMENT_MEMBER_SEARCH } from "../../../../contants/formFields";
import { SET_APPOINTMENT_FORM_STATE } from "../../../../redux/actionTypes/dashboard";
import { selectUserRole } from "../../../../redux/selectors/user";
import { NextChiefNameMapper } from "../../../../utils/helper";
import styles from "./SearchFilter.styles";

const SKIP_INPUTS = [
  APPOINTMENT_MEMBER_SEARCH.APPLICATION_TYPE,
  APPOINTMENT_MEMBER_SEARCH.APPLICATION_FOR,
];

const prepareFormData = (formValues, chiefLabel) => {
  const sanitizeFormValues = omit(SKIP_INPUTS, formValues);

  return Object.keys(sanitizeFormValues).reduce((acc, key) => {
    let result = { [key]: sanitizeFormValues[key] };

    if (key === APPOINTMENT_MEMBER_SEARCH.CHEIF_SI) {
      const newKey = `${chiefLabel.toLowerCase()}Id`;
      result = { [newKey]: sanitizeFormValues[key] };
    }
    return Object.assign(acc, result);
  }, {});
};

// MD WD YMD YWD

const DIVISION_OPTIONS = [
  {
    value: 1,
    key: "MD",
  },
  {
    value: 2,
    key: "WD",
  },
  {
    value: 37,
    key: "YMD",
  },
  {
    value: 3,
    key: "YWD",
  },
];

function SearchFilter({ onSubmit }) {
  const userRole = useSelector(selectUserRole);
  const dispatch = useDispatch();
  const selectChiefLabel = NextChiefNameMapper[userRole];
  const location = useLocation();

  const [key, setKey] = useState(0);

  useEffect(() => {
    setKey((prevKey) => prevKey + 1);
  }, [location.pathname]);

  return (
    <Box>
      <AppointmentPageTopInfo />
      <Formik
        key={key}
        initialValues={{}}
        onSubmit={(values) => {
          const formValues = prepareFormData(values, selectChiefLabel);
          dispatch({
            type: SET_APPOINTMENT_FORM_STATE,
            payload: formValues,
          });
          onSubmit(formValues);
        }}
      >
        {({ values, handleChange, handleSubmit, setFieldValue }) => (
          <form onSubmit={handleSubmit}>
            <Box style={styles.search}>
              <Box width="39%">
                <Dropdown
                  name={APPOINTMENT_MEMBER_SEARCH.DIVISION}
                  value={values[APPOINTMENT_MEMBER_SEARCH.DIVISION]}
                  options={DIVISION_OPTIONS}
                  label="Select Division"
                  onChange={handleChange}
                  showCross
                  handleClearValue={() =>
                    setFieldValue(APPOINTMENT_MEMBER_SEARCH.DIVISION, "")
                  }
                  // multiple
                  inputProps={{ required: false }}
                />
              </Box>
              <Box width="39%">
                <InputField
                  name={APPOINTMENT_MEMBER_SEARCH.SEARCH_MEMBER}
                  value={values[APPOINTMENT_MEMBER_SEARCH.SEARCH_MEMBER]}
                  label="Member Name/ID"
                  onChange={handleChange}
                />
              </Box>
              <Box
                sx={{
                  flex: { xs: "none", md: "none" },
                  width: { xs: "auto", md: "15%" },
                  maxWidth: { xs: "300px" },
                  marginLeft: { xs: "", md: "5px" },
                }}
              >
                <MuiButton
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                >
                  Search
                </MuiButton>
              </Box>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
}

export default SearchFilter;
